import React, { useContext } from "react";
import ListUsers from "./List";
import AddUser from "./Add";
import ChangePassword from "./ChangePassword";
import UsersAdministrationHelp from "./Help";
import View from "common/View";
import ActionsContext from "common/ActionsContext";
import BqnContext from "common/BqnContext";

const options = [
  {
    signal: "add-user",
    label: "Add User",
  },
];

export const UsersAdmin = () => {
  const actions = useContext(ActionsContext);
  const {
    clusterStatus: { mode },
  } = useContext(BqnContext);

  function syncSshKeys() {
    ifCl
      .run("system users ssh sync")
      .then((response) =>
        showModalInfo("SSH keys synchronized correctly", response)
      );
  }

  return (
    <View
      title="Available Users"
      className="container-lg"
      Help={UsersAdministrationHelp}
      options={options}
    >
      <div className="margin-b-5">
        <button
          type="button"
          className="btn btn-default waves-effect shadow-none"
          onClick={() => actions.send("add-user")}
        >
          <i className="material-icons">add_circle</i>
          <span>Add User...</span>
        </button>
        {mode === "cluster" && (
          <button
            type="button"
            className="btn btn-default waves-effect shadow-none hidden-to-operators"
            onClick={() => syncSshKeys()}
          >
            <i className="material-icons">swap_vert</i>
            <span>Sync SSH keys</span>
          </button>
        )}
      </div>
      <ListUsers />
      <AddUser />
      <ChangePassword />
    </View>
  );
};

export default UsersAdmin;
